import { useState } from 'react';
import useMediaQuery from './useMediaQuery';

/** Phone layout for library pages: record cards, the filter sheet and the compact header.
 * Matches the `max-width: 640px` rules in `global.css` ("Shared responsive library contract"). */
export const LIBRARY_PHONE_QUERY = '(max-width: 640px)';

function matchesNow(query: string): boolean {
  return typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia(query).matches;
}

/** Reads the query on the first render, so a phone never mounts the desktop table first. */
export default function useLibraryPhoneLayout(): boolean {
  const [initial] = useState(() => matchesNow(LIBRARY_PHONE_QUERY));
  return useMediaQuery(LIBRARY_PHONE_QUERY, initial);
}
